exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-width: 0) and (max-width: 410px) {\n.hider-vid-spacer[data-v-10fc478f] {\n    min-height: 0 !important;\n}\n}\ntextarea[data-v-10fc478f] {\n  -webkit-text-fill-color: #4a4a4a;\n  opacity: 1;\n}\n", ""]);

// exports
